let groups = [];
function byPosition({ position: posA }, { position: posB }) {
  return posA - posB;
}

/**
 * Reducer to make property grouping based on entity id of the associatedProperty,
 * keeping the position in group and items
 * @param acc accumulator
 * @param record of { data, associatedProperty, position }
 * @param index
 */
function groupReducer(acc, record, index) {
  const { data, position, recordId, confidentiality, ...rest } = record;
  let { associatedProperty = {} } = record;
  let { entity } = associatedProperty;

  if (!entity) {
    // NOTE: this block adds a custom property
    entity = { id: index * -1 };
    associatedProperty = { entity };
    console.warn('No entity information provided, we cannot fully group the report');
  }

  const { id } = entity;
  const currententityid = data.entity.id;
  const curentGroupedData = groups.find(a => a.recordID === currententityid && a.relatedRecordID === id);
  if (!!curentGroupedData) {
    const existingValue = acc[-curentGroupedData.groupID];
    if (!!existingValue) {
      const existingGroupedData = groups.find(
        a => a.recordID === existingValue.edpRecordId && a.groupID === curentGroupedData.groupID
      );
      if (!!existingGroupedData) {
        const sortedData = [
          ...(Array.isArray(existingValue.data) ? existingValue.data : [existingValue.data]),
          { ...data, position, recordId, confidentiality },
        ].sort(byPosition);
        return { ...acc, [-curentGroupedData.groupID]: { ...existingValue, data: sortedData } };
      }
    }
    return {
      ...acc,
      [-curentGroupedData.groupID]: {
        ...rest,
        associatedProperty,
        data: { ...data, position, recordId, confidentiality },
        position,
      },
    };
  }
  return {
    ...acc,
    [recordId]: { ...rest, associatedProperty, data: { ...data, position, recordId, confidentiality }, position },
  };
}

/**
 * To group records by group id, keep the position by item and grouped record
 * @params records array of { data, associatedProperty, position }
 * */
export function groupByPropertyGroups(records, associatedgroups) {
  groups = associatedgroups;
  const groupedRecords = records.reduce(groupReducer, {});
  return Object.values(groupedRecords).sort(byPosition);
}
